import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const PolygonLogoCircle = t0 => {
  const $ = _c(17);
  let className;
  let rest;
  let square;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      square,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = square;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    square = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[5] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = square ? 0 : 12;
  let t4;
  if ($[7] !== t3) {
    t4 = <rect fill="#6C00F6" height={24} rx={t3} width={24} />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M10.27 9.989 8.97 9.234l-3.896 2.263v4.51l3.896 2.256 3.896-2.255V8.993l2.162-1.252 2.162 1.252v2.504l-2.162 1.252-1.299-.754v2.006l1.299.755 3.896-2.255V7.99l-3.896-2.256-3.896 2.255v7.015L8.97 16.257l-2.162-1.252v-2.512l2.162-1.252 1.299.754z" fill="#FFF" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <g fill="none" fillRule="nonzero">{t4}{t5}</g>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== className || $[13] !== rest || $[14] !== t2 || $[15] !== t6) {
    t7 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[12] = className;
    $[13] = rest;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export const PolygonLogoCircleMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm3.029 5.735L11.133 7.99v7.015L8.97 16.257l-2.162-1.252v-2.512l2.162-1.252 1.299.754V9.99L8.97 9.234l-3.896 2.263v4.51l3.896 2.256 3.896-2.255V8.993l2.162-1.252 2.162 1.252v2.504l-2.162 1.252-1.299-.754v2.006l1.299.755 3.896-2.255V7.99l-3.896-2.256Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};